export function truncateString(text: string, length: number): string {
    if (!text) return "";

    return text.length <= length ? text : text.substring(0, length);
}
